import { Swiper, Navigation } from '@hh/global.js'

class HHInsideKit extends HTMLElement {
  constructor() {
    super()

    this.sliderInited = false
    this.insideKitSlider = ''

    this.initSlider()
  }

  getDevice () {
    if (window.innerWidth >= 750) {
      return (window.innerWidth >= 990) ? 'desktop' : 'tablet'
    } else {
      return 'mobile'
    }
  }

  checkConditionSlider () {
    switch (this.getDevice()) {
      case 'desktop':
        return this.itemCount > 4
      break;
      case 'tablet':
        return this.itemCount > 3
      break;
      case 'mobile':
        return this.itemCount > 2
      break;
    }

    return false;
  }

  initSlider () {
    Swiper.use([Navigation])

    this.device = this.getDevice()

    window.addEventListener('resize', () => {
      const device = this.getDevice()
      if (device != this.device) {
        this.device = device
        this.toggleSlider()
      }
    })

    this.toggleSlider()
  }

  toggleSlider () {
    if (this.checkConditionSlider()) {
      if (!this.sliderInited) {
        this.insideKitSlider = new Swiper(this.querySelector('.js-slider'), {
          navigation: {
            nextEl: this.querySelector('.js-next'),
            prevEl: this.querySelector('.js-prev'),
          },
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            type: "progressbar",
          },
          slidesPerView: 2,
          spaceBetween: 10,
          breakpoints: {
            750: {
              slidesPerView: 3,
              spaceBetween: 0
            },
            990: {
              slidesPerView: 4,
              spaceBetween: 0
            }
          }
        })

        this.sliderInited = true
      }
    } else if (this.insideKitSlider && this.sliderInited) {
      this.insideKitSlider.destroy( true, true )
    }
  }

  get itemCount () {
    return parseInt(this.getAttribute('data-count') || '0')
  }
}

customElements.define('hh-inside-kit', HHInsideKit)
